const EmptyMessage = ({ message = "Nenhum registro encontrado.", description, style, className = "", messageStyle = {}, noMessage = false, descriptionStyle = {}, imgWidth = 56 }) => {
    return (
        <div style={style} className={`d-flex flex-column align-items-center gap-24 ${className}`}>
            <img src="/images/EmptyState.svg" alt="emptyStateIcon" width={imgWidth} />

            {noMessage ? null : (
                <span className="tt-16 text-center" style={{ fontWeight: "600", whiteSpace: "pre-wrap", color: "#9ca3af", ...messageStyle }}>
                    {message}
                </span>
            )}

            {description && (
                <span className="tt-14 color-dark-5 text-center" style={{ whiteSpace: "pre-wrap", marginTop: -20, ...descriptionStyle }}>
                    {description}
                </span>
            )}
        </div>
    );
};

export default EmptyMessage;
